document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.formula-addon');
  if (!wrapper) return;

  const checkboxes = Array.from(wrapper.querySelectorAll('.formula-addon__checkbox'));
  if (checkboxes.length === 0) return;

  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) {
    console.error('formula-addon-selector: could not find the add-to-cart form');
    return;
  }

  const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
  if (!submitButton) {
    console.error('formula-addon-selector: could not find the submit button inside the form');
    return;
  }

  // Tracks the order in which checkboxes were checked, oldest first.
  // checkedOrder[0] (if any) is always the "free" one.
  let checkedOrder = [];

  function updateSelectionStates() {
    // Drop anything that's been unchecked
    checkedOrder = checkedOrder.filter((cb) => cb.checked);

    // Add newly checked boxes to the end of the order
    checkboxes.forEach((cb) => {
      if (cb.checked && !checkedOrder.includes(cb)) {
        checkedOrder.push(cb);
      }
    });

    checkboxes.forEach((cb) => {
      const item = cb.closest('.formula-addon__item');
      if (!item) return;

      item.classList.remove('is-free', 'is-extra');

      if (!cb.checked) return;

      if (checkedOrder[0] === cb) {
        item.classList.add('is-free');
      } else {
        item.classList.add('is-extra');
      }
    });
  }

  function getSelectedFormulaVariantIds() {
    return checkedOrder.map((cb) => cb.dataset.variantId);
  }

  checkboxes.forEach((cb) => {
    cb.addEventListener('change', updateSelectionStates);
  });

  submitButton.addEventListener(
    'click',
    async function (event) {
      const selectedFormulaVariantIds = getSelectedFormulaVariantIds();

      if (selectedFormulaVariantIds.length === 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const variantIdInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');

      if (!variantIdInput) {
        console.error('formula-addon-selector: missing input[name="id"] in the form');
        return;
      }

      const items = [
        {
          id: variantIdInput.value,
          quantity: quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1,
        },
      ];

      selectedFormulaVariantIds.forEach((variantId) => {
        items.push({ id: variantId, quantity: 1 });
      });

      const originalText = submitButton.textContent;
      submitButton.disabled = true;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Could not add to cart');
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.location.href = window.Shopify.routes.root + 'cart';
      } catch (err) {
        console.error('formula-addon-selector: add to cart failed', err);
        alert(
          document.documentElement.lang === 'sv'
            ? 'Något gick fel, försök igen.'
            : 'Something went wrong, please try again.'
        );
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    },
    true
  );
});